import { BehaviorSubject } from 'rxjs';
export const getTableStore = () => {
    const getInitialState = (initialSort, initialPagination) => ({
        items: [],
        isLoading: false,
        totalRecords: 0,
        sort: initialSort || {
            key: '',
            direction: undefined
        },
        pagination: initialPagination || {
            pageNumber: 0,
            pageSize: 0
        },
        searchValue: ''
    });
    const tableSubject = new BehaviorSubject(getInitialState());
    let initialSort;
    let initialPagination;
    const initialize = (tableConfig) => {
        initialSort = tableConfig.initialSort;
        initialPagination = tableConfig.initialPagination;
        tableSubject.next(getInitialState(initialSort, initialPagination));
    };
    const subscribe = (callback) => tableSubject.subscribe(callback);
    const startFetching = () => {
        tableSubject.next({ ...tableSubject.getValue(), isLoading: true });
    };
    const fetchSuccess = (items, totalRecords) => {
        const identifiedItems = items.map((value, index) => ({
            ...value,
            key: index
        }));
        tableSubject.next({
            ...tableSubject.getValue(),
            items: identifiedItems,
            totalRecords: totalRecords,
            isLoading: false
        });
    };
    const fetchFail = () => {
        tableSubject.next({
            ...tableSubject.getValue(),
            isLoading: false
        });
    };
    const updateSort = (sort) => {
        tableSubject.next({
            ...tableSubject.getValue(),
            sort: sort
        });
    };
    const updatePagination = (pagination) => {
        tableSubject.next({
            ...tableSubject.getValue(),
            pagination: pagination
        });
    };
    const updateSearchValue = (value) => {
        tableSubject.next({
            ...tableSubject.getValue(),
            searchValue: value
        });
    };
    const resetFilters = () => {
        tableSubject.next({
            ...tableSubject.getValue(),
            searchValue: '',
            sort: initialSort,
            pagination: initialPagination
        });
    };
    const resetPageNumber = () => {
        const newPagination = {
            pageNumber: 1,
            pageSize: getPagination().pageSize
        };
        tableSubject.next({
            ...tableSubject.getValue(),
            pagination: newPagination
        });
    };
    const reset = () => {
        tableSubject.next(getInitialState());
    };
    const getSort = () => tableSubject.getValue().sort;
    const getPagination = () => tableSubject.getValue().pagination;
    const getSearchValue = () => tableSubject.getValue().searchValue;
    const getItems = () => tableSubject.getValue().items;
    return {
        getInitialState,
        initialize,
        subscribe,
        startFetching,
        fetchSuccess,
        fetchFail,
        updateSort,
        updatePagination,
        updateSearchValue,
        resetFilters,
        resetPageNumber,
        reset,
        getSort,
        getPagination,
        getSearchValue,
        getItems
    };
};
